import http from '@/axios/http'

// 获取/搜索下挂设备
export function queryHangingDevice(data) {
  return http({
    url: '/api/printer/list',
    method: 'post',
    data,
  })
}

// 获取打印服务器
export function getPrinterServer(data) {
  return http({
    url: '/api/printer/fir/list',
    method: 'post',
    data,
  })
}

// 获取打印机
export function getPrinterList(did) {
  return http({
    url: '/api/printer/sec/list',
    method: 'post',
    data: {
      did,
    }
  })
}

// 修改打印机信息
export function updatePrinter(data){
  return http({
    url: '/api/printer/update',
    method: 'post',
    data,
  })
}